import { AppConfig } from '@shared/definitions';

export const appConfig: AppConfig = {
  /* All three apps on this origin (webshop, user portal, order2seat) share these localStorage
     records, so they read the expiry the same way or one of them retires a token the others still
     hold. `minutes` mirrors the API's Jwt:TokenExpirationInMinutes for tokens that cannot be read. */
  tokenExpiration: { source: 'jwt', minutes: 5 },
  app: 'pauly-shop',
  appTitle: 'Pauly Shop',
  email: '',
  gtm: '',
  logo: {
    light: '/logo/logo-light-pauly.svg',
    dark: '/logo/logo-dark-pauly.svg',
    mark: '/logo/logo-dark-pauly.svg',
  },
  language: {
    defaultLanguage: 'nl',
    languages: [
      { code: 'nl', iconFlagPath: 'assets/flags/netherlands.png' },
      { code: 'en', iconFlagPath: 'assets/flags/uk.png' },
    ],
  },
  localStorageAuthPrefix: 'plys-',
  withBackendErrorFieldsMapping: true,
  version: '1.4.0',
  disabledAuthPopup: true,
};
